/** Auto-generated Excel column/header enums for golf exports. */

export enum GolfExcelHeader {
  NumberOfMinutes = "# of Minutes",
  AddressLine1 = "AddressLine1",
  AddressLine2 = "AddressLine2",
  AddressLine3 = "AddressLine3",
  AllocationBlockCode = "AllocationBlockCode",
  AllocationBlockName = "AllocationBlockName",
  AllowTaxOnGratuity = "AllowTaxOnGratuity",
  AllowTaxOnServiceCharge = "AllowTaxOnServiceCharge",
  AutoReceipt = "AutoReceipt",
  AvailableDaysOfWeek = "Available Days of Week",
  AvailableDaysOfTheWeek = "Available Days of the Week",
  AvgPlay18Holes = "AvgPlay18Holes",
  AvgPlay9Holes = "AvgPlay9Holes",
  CancelReason = "CancelReason",
  CartFeeAmountDollars = "Cart Fee Amount($)",
  CartFeeItemNumber = "Cart Fee Item #",
  Category = "Category",
  CategoryGroupName = "CategoryGroupName",
  City = "City",
  Closed = "Closed",
  ClosedQ = "Closed ?",
  ColorCode = "ColorCode",
  Comments = "Comments",
  ContactType = "ContactType",
  Country = "Country",
  Course = "Course",
  CourseName = "CourseName",
  DaysOut = "DaysOut",
  DaysOutEnd = "DaysOutEnd",
  DaysOutStart = "DaysOutStart",
  DiscountReason = "DiscountReason",
  DiscountType = "DiscountType",
  DisplayOnTeesheet = "DisplayOnTeesheet",
  EligibleForDiscount = "EligibleForDiscount",
  EndDate = "End Date",
  EndTime = "End Time",
  EndDate2 = "EndDate",
  GreenFeeAmountDollars = "Green Fee Amount($)",
  GreenFeeItemNumber = "Green Fee Item #",
  GuaranteeType = "GuaranteeType",
  Id = "Id",
  IntervalMinutes = "Interval Minutes",
  IsActive = "IsActive",
  IsAmountOrPercentage = "IsAmountOrPercentage",
  IsAvailableOnWeb = "IsAvailableOnWeb",
  IsDefault = "IsDefault",
  IsDefaultTax = "IsDefaultTax",
  IsNineHoles = "IsNineHoles",
  IsPrimary = "IsPrimary",
  IsPrivateInfo = "IsPrivateInfo",
  IsSupressReceipt = "IsSupressReceipt",
  Level = "Level",
  Location = "Location",
  MinimumPlayers = "MinimumPlayers",
  Name = "Name",
  OutletName = "OutletName",
  Outlets = "Outlets",
  PlayerType = "PlayerType",
  PlayerTypes = "PlayerTypes",
  PostalCode = "PostalCode",
  ProfitCenter = "ProfitCenter",
  RateType = "Rate Type",
  RateTypes = "RateTypes",
  RepresentativeFname = "RepresentativeFname",
  RepresentativeLname = "RepresentativeLname",
  ResvRqd = "ResvRqd",
  ShowOnTeeSheet = "Show on Tee Sheet",
  StartDate = "Start Date",
  StartTime = "Start Time",
  StartDate2 = "StartDate",
  State = "State",
  SwitchTime = "SwitchTime",
  SwitchToAllocationBlockName = "SwitchToAllocationBlockName",
  TaxAmount = "TaxAmount",
  TaxName = "TaxName",
  TaxValue = "TaxValue",
  TemplateCode = "Template Code",
  TemplateName = "Template Name",
  TerminalId = "TerminalId",
  Terms = "Terms",
  Time = "Time",
  Type = "Type",
  Value = "Value",
  VendorCode = "VendorCode",
  VendorName = "VendorName",
  VendorType = "VendorType",
}

export enum GolfExcelSourceField {
  NumberOfMinutes = "# of Minutes",
  N9Hole = "9 Hole",
  Active = "Active",
  Address = "Address",
  AllocationBlockCode = "Allocation Block Code",
  AllocationBlockName = "Allocation Block Name",
  AllowTaxOnGratuity = "Allow Tax on Gratuity",
  AllowTaxOnServiceCharge = "Allow Tax on Service Charge",
  AutoPrintsReceipts = "Auto Prints Receipts",
  AvailableDaysOfWeek = "Available Days of Week",
  AvailableDaysOfTheWeek = "Available Days of the Week",
  AvailableOnWeb = "Available on Web",
  CancelReasons = "Cancel Reasons",
  CartFeeAmountDollars = "Cart Fee Amount($)",
  CartFeeItemNumber = "Cart Fee Item #",
  CategoryGroup = "Category Group",
  CategoryName = "Category Name",
  City = "City",
  ClosedQ = "Closed ?",
  ColorOptions = "Color Options",
  Comments = "Comments",
  ContactType = "Contact Type",
  Country = "Country",
  Course = "Course",
  CourseName = "Course Name",
  DaysOutStart = "Days Out Start",
  DaysOut = "Days out",
  DaysOutEnd = "Days out End",
  DaysOutStart2 = "Days out Start",
  Default = "Default",
  DefaultOutlet = "Default Outlet",
  DefaultToAllRetailItems = "Default to all Retail Items",
  DiscountReason = "Discount Reason",
  DiscountType = "Discount Type",
  DurationOfPlay18Holes = "Duration of Play 18 Holes",
  DurationOfPlay9Holes = "Duration of Play 9 Holes",
  EligibleForDiscount = "Eligible for Discount",
  EndDate = "End Date",
  EndTime = "End Time",
  FirstName = "First Name",
  GreenFeeAmountDollars = "Green Fee Amount($)",
  GreenFeeItemNumber = "Green Fee Item #",
  Guarantee = "Guarantee",
  IntervalMinutes = "Interval Minutes",
  IsPrimary = "Is Primary",
  IsPrivateInfo = "Is Private Info",
  LastName = "Last Name",
  LessonLocations = "Lesson Locations",
  MinNumberPlayers = "Min # Players",
  Outlet = "Outlet",
  OutletName = "Outlet Name",
  PercentageOrFlatAmount = "Percentage or Flat Amount",
  PlayerType = "Player Type",
  PostalCode = "Postal Code",
  QuickSaleCategory = "Quick Sale Category",
  RateType = "Rate Type",
  ShowOnTeeSheet = "Show on Tee Sheet",
  StartDate = "Start Date",
  StartTime = "Start Time",
  State = "State",
  SubCategoryName = "Sub Category Name",
  SubCategoryNumber = "Sub Category Number",
  SuppressOnReceipt = "Suppress on Receipt",
  SwitchTo = "Switch To",
  TaxName = "Tax Name",
  TemplateCode = "Template Code",
  TemplateName = "Template Name",
  Time = "Time",
  Value = "Value",
  VendorCode = "Vendor Code",
  VendorName = "Vendor Name",
  VendorType = "Vendor Type",
}

export enum GolfExcelSheetName {
  AllocationBlock = "AllocationBlock",
  CancellationReasons = "CancellationReasons",
  Category = "Category",
  CategoryGroup = "CategoryGroup",
  Course = "Course",
  DiscountReasons = "DiscountReasons",
  DiscountTypes = "DiscountTypes",
  LessonLocation = "LessonLocation",
  Outlet = "Outlet",
  PlayerType = "PlayerType",
  PlayerTypeMapping = "PlayerTypeMapping",
  QuickSaleCategory = "QuickSaleCategory",
  RateType = "RateType",
  RateTypeDaysOut = "RateTypeDaysOut",
  RateTypeMapping = "RateTypeMapping",
  RatesSetup = "Rates Setup",
  RetailItem = "RetailItem",
  SubCategory = "SubCategory",
  Tax = "Tax",
  TeeTimeIntervalSetup = "Tee Time Interval Setup",
  TeeTimeIntervalTemplates = "Tee Time Interval Templates",
  Vendor = "Vendor",
  VendorContactInformation = "VendorContactInformation",
  VendorType = "VendorType",
}
